import {
  toast,
  Toaster as BaseToaster,
  ToastBar,
  ToasterProps,
  ToastType,
  ToastOptions,
} from "react-hot-toast";
import { Close, Error, Success } from "../icons";
import styles from "./Toaster.module.scss";
import classNames from "classnames";

const TOASTER_OPTIONS: Partial<Record<ToastType, ToastOptions>> = {
  success: {
    className: classNames(styles.toastBar, styles.toastBar__success),
    icon: <Success className={classNames(styles.icon, styles.icon__success)} />,
  },
  error: {
    className: classNames(styles.toastBar, styles.toastBar__error),
    icon: <Error className={classNames(styles.icon, styles.icon__error)} />,
  },
};

export function Toaster({ containerClassName, ...restProps }: ToasterProps) {
  return (
    <BaseToaster
      position="bottom-right"
      {...restProps}
      containerClassName={classNames(styles.container, containerClassName)}
      toastOptions={TOASTER_OPTIONS}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== "loading" && (
                <Close
                  className={styles.closeBtn}
                  onClick={() => toast.dismiss(t.id)}
                />
              )}
            </>
          )}
        </ToastBar>
      )}
    </BaseToaster>
  );
}
